import { createAsyncThunk } from "@reduxjs/toolkit";

import { fetchPetsJobs } from "../../apis/petJobs";

export const fetchPetsJobsData = createAsyncThunk(
  "petsJobs/fetchPetsJobs",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchPetsJobs();
      return response;
    } catch (error: any) {
      console.error("Error fetching pets jobs:", error);
      return rejectWithValue(error.message || "Failed to fetch pets jobs");
    }
  }
);
